import deliveryMethods from '../mixins/delivery-methods'

export default {        
    methods: {
        /**
         * 注文内容確認の通信結果を判定し返却を行う
         * @param {*} result 
         * @returns 
         */
        getResultOfOrderConfirmation(result) {
            if (!result || result.status !== deliveryMethods.STATUS_CODE_SUCCESS) {
              return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }
    
            switch (result.data.error_code) {
              case deliveryMethods.ERROR_CODE.EMPTY:
                return { isSuccess: true, code: "", message: "" };
              case deliveryMethods.ERROR_CODE.COM_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_01, message: deliveryMethods.ERROR_MESSAGE.COM_01 };
              case deliveryMethods.ERROR_CODE.COM_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_02, message: deliveryMethods.ERROR_MESSAGE.COM_02 };
              case deliveryMethods.ERROR_CODE.R01_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.R01_01, message: deliveryMethods.ERROR_MESSAGE.R01_01 };
              case deliveryMethods.ERROR_CODE.R01_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.R01_02, message: deliveryMethods.ERROR_MESSAGE.R01_02 };
              case deliveryMethods.ERROR_CODE.R02_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.R02_01, message: deliveryMethods.ERROR_MESSAGE.R02_01 };
              case deliveryMethods.ERROR_CODE.R02_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.R02_02, message: deliveryMethods.ERROR_MESSAGE.R02_02 };
              case deliveryMethods.ERROR_CODE.R02_03:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.R02_03, message: deliveryMethods.ERROR_MESSAGE.R02_03 };
              case deliveryMethods.ERROR_CODE.T03_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.T03_01, message: deliveryMethods.ERROR_MESSAGE.T03_01 };
              case deliveryMethods.ERROR_CODE.T03_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.T03_02, message: deliveryMethods.ERROR_MESSAGE.T03_02 };
              default:
                return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }        
          },
          /**
           * 注文内容取得の通信結果を判定し返却を行う
           * @param {*} result 
           * @returns 
           */
          getResultOfGetOrderConfirmation(result) {
            if (!result || result.status !== deliveryMethods.STATUS_CODE_SUCCESS) {
              return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }
    
            switch (result.data.error_code) {
              case deliveryMethods.ERROR_CODE.EMPTY:
                return { isSuccess: true, code: "", message: "" };
              case deliveryMethods.ERROR_CODE.COM_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_01, message: deliveryMethods.ERROR_MESSAGE.COM_01 };
              case deliveryMethods.ERROR_CODE.COM_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_02, message: deliveryMethods.ERROR_MESSAGE.COM_02 };
              case deliveryMethods.ERROR_CODE.S01_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S01_01, message: deliveryMethods.ERROR_MESSAGE.S01_01 };
              case deliveryMethods.ERROR_CODE.S01_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S01_02, message: deliveryMethods.ERROR_MESSAGE.S01_02 };              
              default:
                return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }        
          }, 
          /**
           * 注文内容更新の結果を判定し返却を行う
           * @param {*} result 
           * @returns 
           */
          getResultOfOrderUpdate(result) {
            if (!result || result.status !== deliveryMethods.STATUS_CODE_SUCCESS) {
              return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }
    
            switch (result.data.error_code) {
              case deliveryMethods.ERROR_CODE.EMPTY:
                return { isSuccess: true, code: "", message: "" };
              case deliveryMethods.ERROR_CODE.COM_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_01, message: deliveryMethods.ERROR_MESSAGE.COM_01 };
              case deliveryMethods.ERROR_CODE.COM_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_02, message: deliveryMethods.ERROR_MESSAGE.COM_02 };
              case deliveryMethods.ERROR_CODE.S01_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S01_01, message: deliveryMethods.ERROR_MESSAGE.S01_01 };
              case deliveryMethods.ERROR_CODE.S01_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S01_02, message: deliveryMethods.ERROR_MESSAGE.S01_02 };              
              default:
                return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }                     
          },    
          /**
           * 注文申込の通信結果を判定し返却を行う
           * @param {*} result 
           * @returns 
           */
          getResultOfOrderApplication(result) {                        
            if (!result || result.status !== deliveryMethods.STATUS_CODE_SUCCESS) {
              return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }
              
            switch (result.data.error_code) {
              case deliveryMethods.ERROR_CODE.EMPTY:
                return { isSuccess: true, code: "", message: "注文の申し込みが完了しました" };
              case deliveryMethods.ERROR_CODE.COM_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_01, message: deliveryMethods.ERROR_MESSAGE.COM_01 };
              case deliveryMethods.ERROR_CODE.COM_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_02, message: deliveryMethods.ERROR_MESSAGE.COM_02 };
              case deliveryMethods.ERROR_CODE.S01_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S01_01, message: deliveryMethods.ERROR_MESSAGE.S01_01 };
              case deliveryMethods.ERROR_CODE.T01_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.T01_01, message: deliveryMethods.ERROR_MESSAGE.T01_01 };              
              case deliveryMethods.ERROR_CODE.T03_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.T03_01, message: deliveryMethods.ERROR_MESSAGE.T03_01 };
              case deliveryMethods.ERROR_CODE.T03_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.T03_02, message: deliveryMethods.ERROR_MESSAGE.T03_02 };
              default:
                return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }                         
          },
          /**
           * 請求ユーザー取得の通信結果を判定し返却を行う
           * @param {*} result 
           * @returns 
           */
          getResultOfGetBillingUser(result) {                        
            if (!result || result.status !== deliveryMethods.STATUS_CODE_SUCCESS) {
              return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }
              
            switch (result.data.error_code) {
              case deliveryMethods.ERROR_CODE.EMPTY:
                return { isSuccess: true, code: "", message: "" };
              case deliveryMethods.ERROR_CODE.COM_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_01, message: deliveryMethods.ERROR_MESSAGE.COM_01 };
              case deliveryMethods.ERROR_CODE.COM_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_02, message: deliveryMethods.ERROR_MESSAGE.COM_02 };
                case deliveryMethods.ERROR_CODE.R01_01:
                  return { isSuccess: false, code: deliveryMethods.ERROR_CODE.R01_01, message: deliveryMethods.ERROR_MESSAGE.R01_01 };
                case deliveryMethods.ERROR_CODE.R01_02:
                  return { isSuccess: false, code: deliveryMethods.ERROR_CODE.R01_02, message: deliveryMethods.ERROR_MESSAGE.R01_02 };
              default:
                return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }                         
          },
          /**
           * 商品一覧取得の通信結果を判定し返却を行う
           * @param {*} result 
           * @returns 
           */
          getResultOfGetProducts (result) {
            if (!result || result.status !== deliveryMethods.STATUS_CODE_SUCCESS) {
              return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }
              
            switch (result.data.error_code) {
              case deliveryMethods.ERROR_CODE.EMPTY:
                return { isSuccess: true, code: "", message: "" };
              case deliveryMethods.ERROR_CODE.COM_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_01, message: deliveryMethods.ERROR_MESSAGE.COM_01 };
              case deliveryMethods.ERROR_CODE.COM_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_02, message: deliveryMethods.ERROR_MESSAGE.COM_02 };
                case deliveryMethods.ERROR_CODE.S02_01:
                  return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S02_01, message: deliveryMethods.ERROR_MESSAGE.S02_01 };
                case deliveryMethods.ERROR_CODE.S02_02:
                  return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S02_02, message: deliveryMethods.ERROR_MESSAGE.S02_02 };
                case deliveryMethods.ERROR_CODE.S02_03:
                  return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S02_03, message: deliveryMethods.ERROR_MESSAGE.S02_03 };
                case deliveryMethods.ERROR_CODE.S02_04:
                  return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S02_04, message: deliveryMethods.ERROR_MESSAGE.S02_04 };
                case deliveryMethods.ERROR_CODE.S02_05:
                  return { isSuccess: false, code: deliveryMethods.ERROR_CODE.S02_05, message: deliveryMethods.ERROR_MESSAGE.S02_05 };
              default:
                return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }                         
          },
          /**
           * クリニック情報取得の通信結果を判定し返却を行う
           * @param {*} result 
           * @returns 
           */
          getResultOfGetClinic(result) {                        
            if (!result || result.status !== deliveryMethods.STATUS_CODE_SUCCESS) {
              return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }
              
            switch (result.data.error_code) {
              case deliveryMethods.ERROR_CODE.EMPTY:
                return { isSuccess: true, code: "", message: "" };
              case deliveryMethods.ERROR_CODE.COM_01:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_01, message: deliveryMethods.ERROR_MESSAGE.COM_01 };
              case deliveryMethods.ERROR_CODE.COM_02:
                return { isSuccess: false, code: deliveryMethods.ERROR_CODE.COM_02, message: deliveryMethods.ERROR_MESSAGE.COM_02 };
                case deliveryMethods.ERROR_CODE.U01_01:
                  return { isSuccess: false, code: deliveryMethods.ERROR_CODE.U01_01, message: deliveryMethods.ERROR_MESSAGE.U01_01 };                
              default:
                return { isSuccess: false, code: "", message: deliveryMethods.ERROR_MESSAGE.COMMUNICATION_ERROR_MESSAGE };
            }                         
          },
        }
      }


// WEBPACK FOOTER //
// ./src/mixins/ResultUtil.js